module.exports = __webpack_public_path__ + "static/media/0.7f51920e.png";